import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import "./index.css";
import Home from "./app/screens/home";
import Signin from "./app/screens/signin";
import LoadingScreen from "./app/screens/loading";
import AsyncStorage from "@react-native-async-storage/async-storage";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    "Root element not found. Ensure you have an element with id 'root' in your HTML."
  );
}

function App() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function checkToken() {
      const token = await AsyncStorage.getItem("token");

      setTimeout(() => {
        if (token) {
          navigate("/home");
        } else {
          navigate("/");
        }
        setLoading(false);
      }, 1000);
    }
    checkToken();
  }, [navigate]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Routes>
      <Route path="/" element={<Signin />} />
      <Route path="/home" element={<Home />} />
    </Routes>
  );
}

// Create the root
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
